// Helpers compartidos por las summary cards de los tabs (Resultados, Ventas,
// Gastos, Costos, Activos, No Operacional, Rentabilidad).

/**
 * Devuelve la card "vacía" usada como placeholder mientras el endpoint aún
 * no respondió (estado inicial post-mounted). El v-if del slot/template del
 * caller oculta los badges opcionales (mom, yoy, grossMargin, efficiency...)
 * mientras los strings extra estén vacíos — mostrar "—" o "0%" daría la
 * falsa señal de un dato calculado en cero.
 *
 * Cada caller puede sumar campos extra con `extra` sin reimplementar el
 * shape base. Ejemplo: `emptyCard({ efficiency: "" })` para ExpensesSummaryCards,
 * `emptyCard({ grossMargin: "" })` para CostosTab.
 */
export function emptyCard(extra = {}) {
    return {
        period: "-",
        amount: 0,
        mom: "",
        yoy: "",
        progressItems: [],
        ...extra,
    };
}
